import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { firstValueFrom } from "rxjs";

import { AccountService } from "@bitwarden/common/auth/abstractions/account.service";
import { FormFieldModule } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";
import { Vfo1I18nPipe, Vfo1TerminologyService } from "@bitwarden/vault";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-org-info",
  templateUrl: "organization-information.component.html",
  imports: [CommonModule, ReactiveFormsModule, FormFieldModule, I18nPipe, Vfo1I18nPipe],
})
export class OrganizationInformationComponent implements OnInit {
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() nameOnly = false;
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() createOrganization = true;
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isProvider = false;
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() acceptingSponsorship = false;
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formGroup?: UntypedFormGroup;
  // FIXME(https://bitwarden.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-output-emitter-ref
  @Output() changedBusinessOwned = new EventEmitter<void>();

  protected readonly vfo1Enabled = inject(Vfo1TerminologyService).enabled;

  constructor(private accountService: AccountService) {}

  async ngOnInit(): Promise<void> {
    if (this.formGroup?.controls?.billingEmail?.value) {
      return;
    }

    const activeAccount = await firstValueFrom(this.accountService.activeAccount$);

    if (activeAccount?.email) {
      this.formGroup?.controls.billingEmail.setValue(activeAccount.email);
    }
  }
}
